import {Avatar} from '@mui/material';
import {useMemo} from 'react';
import {ComponentWithoutChildren} from '../react/types';
import {useOptionalCurrentUser} from './hooks/useOptionalCurrentUser';
import {useUserPublicProfile} from './hooks/useUserPublicProfile';

interface UserAvatarProps {
  id: string;
}

export const UserAvatar: ComponentWithoutChildren<UserAvatarProps> = ({id}: UserAvatarProps) => {
  const currentUserDoc = useOptionalCurrentUser();
  const publicProfile = useUserPublicProfile(id);

  const isCurrentUser = currentUserDoc?.id === id;
  const data = isCurrentUser ? currentUserDoc.get() : publicProfile.get();

  const avatar = data?.avatar;
  const name = data?.name || '';
  const initials = useMemo(() => nameToInitials(name), [name]);
  return (
    /* no-referrer required to prevent 403 responses from googleusercontent.com */
    <Avatar alt={name} slotProps={{img: {referrerPolicy: 'no-referrer'}}} src={avatar?.url}>
      {initials}
    </Avatar>
  );
};

export function nameToInitials(name: string): string {
  if (!name) {
    return '';
  }
  const nameParts = name.split(' ');
  let initials = nameParts[0]?.[0] || '';
  if (nameParts.length > 1) {
    initials += nameParts[nameParts.length - 1]?.[0] || '';
  }
  return initials;
}
